/** Types d'événements du journal d'activité d'un foyer (codes API → clés i18n). */
export const ACTIVITY_TYPES = [
  'item.created',
  'item.updated',
  'item.moved',
  'item.deleted',
  'item.restored',
  'loan.lent',
  'loan.returned',
  'location.created',
  'location.updated',
  'location.moved',
  'location.deleted',
  'location.restored',
  'location.batch_created',
  'photo.created',
  'photo.deleted',
  'attachment.created',
  'attachment.deleted',
  'member.joined',
  'member.left',
  'member.removed',
] as const

export type ActivityType = (typeof ACTIVITY_TYPES)[number]

export const ACTIVITY_SOURCES = ['web', 'mobile', 'mcp', 'import'] as const
export type ActivitySource = (typeof ACTIVITY_SOURCES)[number]
